module.exports = __webpack_public_path__ + "35f3aa7886ebb3e630876989ea5b489c.MP3";